import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=a08f4562&scoped=true&"
import script from "./Preferences.vue?vue&type=script&lang=js&"
export * from "./Preferences.vue?vue&type=script&lang=js&"
import style0 from "./Preferences.vue?vue&type=style&index=0&id=a08f4562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08f4562",
  null
  
)

export default component.exports